module.exports = __webpack_public_path__ + "img/Dashboard.866a4a98.png";